export enum PaymentStatusEnum {
  Succeeded = 'succeeded',
  Failed = 'requires_payment_method',
}
